import { Directive } from '@angular/core';
import { FieldArrayType, FieldArrayTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';

@Directive()
export abstract class BaseFieldArrayType<
  F extends FieldArrayTypeConfig = FieldArrayTypeConfig
> extends FieldArrayType<F> {
  removeField(field: FormlyFieldConfig) {
    const index = this.field.fieldGroup?.indexOf(field) ?? -1;
    if (index !== -1) {
      this.remove(index);
    }
  }
}
